// Строки report_offers для превью и автотеста отчёта — те же, что засевает
// миграция 20261023120000, но все три слота включены (subjects с
// плейсхолдерами, map — тестовый партнёр), чтобы вёрстку можно было проверить
// до наката и до текстов владельца.

import { offersBundle, type ReportOfferRow, type ReportOffersBundle } from "@/lib/report-offers";

const ALL = ["10_11", "12_13", "14_15", "16_18", "18_22"];

export const REPORT_OFFER_FIXTURE: ReportOfferRow[] = [
  {
    id: "00000000-0000-4000-8000-00000000f1a1",
    slot: "final",
    kind: "own",
    active: true,
    priority: 100,
    age_groups: ALL,
    archetypes: [],
    starts_at: null,
    ends_at: null,
    title_az: "Xaricdə hara qəbul ola bilərsən?",
    title_ru: "Куда можно поступить за рубежом?",
    title_en: "Where can you study abroad?",
    text_az: "Azərbaycan attestatı ilə {countries} universitetləri: xərc, tələblər və son tarixlər",
    text_ru: "Вузы {countries} для выпускников с азербайджанским аттестатом: стоимость, требования и сроки",
    text_en: "Universities in {countries} for students with an Azerbaijani school certificate: costs, requirements and deadlines",
    cta_az: "Pulsuz · təxminən 20 dəqiqə",
    cta_ru: "Бесплатно · около 20 минут",
    cta_en: "Free · about 20 minutes",
    qr_note_az: "Arxetipin artıq anketdədir",
    qr_note_ru: "Архетип уже подставлен в анкету",
    qr_note_en: "Your archetype is already filled in",
    url_template: "{abroad_start}",
    short_path: "abroad",
  },
  {
    id: "00000000-0000-4000-8000-00000000f1a2",
    slot: "subjects",
    kind: "own",
    active: true,
    priority: 100,
    age_groups: ["10_11", "12_13", "14_15", "16_18"],
    archetypes: [],
    starts_at: null,
    ends_at: null,
    title_az: "[mətn] Evə yaxın repetitor",
    title_ru: "[текст] Репетитор рядом с домом",
    title_en: "[text] A tutor near home",
    text_az: "[mətn] Xəritədə yaxınlıqdakı repetitorlar",
    text_ru: "[текст] Репетиторы рядом на карте",
    text_en: "[text] Tutors nearby on the map",
    cta_az: "Xəritəni aç",
    cta_ru: "Открыть карту",
    cta_en: "Open the map",
    qr_note_az: "Xəritə",
    qr_note_ru: "Карта",
    qr_note_en: "Map",
    url_template: "{tutors}",
    short_path: "tutors-near",
  },
  {
    id: "00000000-0000-4000-8000-00000000f1a3",
    slot: "map",
    kind: "partner",
    active: true,
    priority: 0,
    age_groups: [],
    archetypes: [],
    starts_at: null,
    ends_at: null,
    title_az: "[TEST] Tərəfdaş",
    title_ru: "[TEST] Партнёр",
    title_en: "[TEST] Partner",
    text_az: "[TEST] Tərəfdaş blokunun nümunəsi",
    text_ru: "[TEST] Пример партнёрского блока",
    text_en: "[TEST] Sample partner block",
    cta_az: "Ətraflı",
    cta_ru: "Подробнее",
    cta_en: "Learn more",
    qr_note_az: null,
    qr_note_ru: null,
    qr_note_en: null,
    url_template: "https://yolutap.com/",
    short_path: null,
  },
];

/** Блоки для мок-отчёта: число стран — 19, как в живом справочнике 13.10. */
export function fixtureOffers(ageGroup: string, lead: string | null, countries: number | null = 19): ReportOffersBundle {
  return offersBundle(REPORT_OFFER_FIXTURE, { ageGroup, lead, now: new Date("2026-10-13T09:00:00Z"), countries });
}
